import { trim } from "lodash";
import parseDecimalNumber from "parse-decimal-number";

export function trunc(str: string, length: number, ending = "") {
  return str.length > length ? `${str.substr(0, length - 1)}${ending}` : str.toString();
}

export function removeDiacritics(str: string) {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ø/i, "");
}

export function removeEmoji(str: string) {
  return str.replace(
    /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
    ""
  );
}

export function toASCII(str: string, allowSpace = false) {
  const re = allowSpace ? /[^a-z0-9\s]/gim : /[^a-z0-9]/gim;
  return trim(str).replace(re, "");
}

export function toNumeric(str: string, fractionSeparator = " ,") {
  const current = str.replace(/[^\d.,]/g, "");
  const num = parseDecimalNumber(current, fractionSeparator);
  return isNaN(num) ? 0 : num;
}

export function toUpperFirst(str: string) {
  return str.substring(0, 1).toUpperCase() + str.substring(1);
}

export function toNumbersOnly(str: string) {
  return (str || "").replace(/[^0-9]/gim, "");
}

export function incrementPaddedString(str: string): string {
  const num = parseInt(str, 10);
  const incremented = num + 1;

  // If the incremented number needs more digits, return it without padding
  if (incremented.toString().length > str.length) {
    return incremented.toString();
  }

  // Otherwise, pad with zeros to maintain the original length
  return incremented.toString().padStart(str.length, "0");
}

export function trimAndRemoveSpaces(str: string) {
  return trim(str).replace(/\s+/g, "");
}
